// App Imports
import { API_URL } from './config/env'
import params from './config/params'

// Helpers

// Render element or component by provided condition

export function renderIf(condition, renderFn) {
  return condition ? renderFn() : null
}

// Substring with ...
export function subString(string = '', length = 0) {
  return string.length > length ? `${ string.substr(0, length) }...` : string
}

// Return empty string if value is null
export function nullToEmptyString(value) {
  return value || ''
}

// Return zero if value is null
export function nullToZero(value) {
  return value === null ? 0 : value
}

// Add (s) to any string by count
export function plural(value) {
  return value === 1 ? '' : 's'
}

// Slug
export function slug(text) {
  return text.toLowerCase().replace(/[^\w ]+/g,'').replace(/ +/g,'-')
}

// Capitalize first letter of string
export function capitalizeFirstLetter(string) {
  return string.replace(/^./, str => str.toUpperCase())
}

// Price format
export function priceFormat(num) {
  if (num === 0) {
    return "0.00";
  }
  num = Math.abs(typeof num === 'number' ? (num % 1 === 0) ? num : num.toFixed(2) : num)
  let n1, n2
  num = num + '' || ''
  n1 = num.split('.')
  n2 = n1[1] || null;
  n1 = n1[0].replace(/(\d)(?=(\d\d)+\d$)/g, "$1,")
  num = n2 ? n1 + '.' + n2 : n1
  return num
}

// Image Kyc
export function imageKyc(image = 'default.jpg') {
  return `${ API_URL }/${ params.kyc.image.path }/${ image }`
}

// To title case
export function toTitleCase(value) {
  return (value || '')
    .toString()
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

// Convert the Address to titleCase
export function toTitleCaseAddress(address) {
  const postcodeRegex = /^[A-Z]{1,2}\d{1,2}[A-Z]?\s?\d[A-Z]{2}$/i;

  return address
    .split(',')
    .map(part => {
      const trimmed = part.trim();

      // If it's a full postcode, leave it uppercase
      if (postcodeRegex.test(trimmed.toUpperCase())) {
        return trimmed.toUpperCase();
      }

      // Otherwise, title-case the individual words
      return trimmed
        .toLowerCase()
        .split(' ')
        .map(word =>
          /^\d+$/.test(word)
            ? word
            : word.charAt(0).toUpperCase() + word.slice(1),
        )
        .join(' ');
    })
    .join(', ');
}

function hslToRgbString(hsl) {
  const regex = /hsl\(\s*(\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/i;
  const match = hsl.match(regex);
  if (!match) return hsl;

  let h = parseInt(match[1], 10);
  let s = parseFloat(match[2]) / 100;
  let l = parseFloat(match[3]) / 100;

  let c = (1 - Math.abs(2 * l - 1)) * s;
  let x = c * (1 - Math.abs(((h / 60) % 2) - 1));
  let m = l - c / 2;
  let r, g, b;

  if (h < 60) [r, g, b] = [c, x, 0];
  else if (h < 120) [r, g, b] = [x, c, 0];
  else if (h < 180) [r, g, b] = [0, c, x];
  else if (h < 240) [r, g, b] = [0, x, c];
  else if (h < 300) [r, g, b] = [x, 0, c];
  else [r, g, b] = [c, 0, x];

  const to255 = (n) => Math.round((n + m) * 255);
  return `rgb(${to255(r)}, ${to255(g)}, ${to255(b)})`;
}

export function sanitizeEmailHtml(html) {
  const wrapper = document.createElement("div");
  wrapper.innerHTML = html;

  // Convert HSL to RGB inline style
  wrapper.querySelectorAll("*").forEach((el) => {
    el.removeAttribute("class");
    const style = el.getAttribute("style");
    if (style && style.includes("hsl")) {
      let newStyle = style.replace(/hsl\(\d+,\s*[\d.]+%,\s*[\d.]+%\)/gi, (hsl) =>
        hslToRgbString(hsl)
      );
      el.setAttribute("style", newStyle);
    }
  });
  
  // Replace YouTube iframe embeds with image thumbnail linking to video
  const iframes = wrapper.querySelectorAll("iframe[src*='youtube.com']");
  iframes.forEach((iframe) => {
    const src = iframe.getAttribute("src");
    const videoIdMatch = src.match(/(?:embed\/|v=)([a-zA-Z0-9_-]+)/);
    if (!videoIdMatch) return;

    const videoId = videoIdMatch[1];

    const img = document.createElement("img");
    img.src = `https://img.youtube.com/vi/${videoId}/0.jpg`;
    img.alt = "Watch on YouTube";
    img.setAttribute(
      "style",
      "max-width:100%; height:auto; border:0; display:block;"
    );

    const link = document.createElement("a");
    link.href = `https://www.youtube.com/watch?v=${videoId}`;
    link.target = "_blank";
    link.appendChild(img);

    iframe.parentElement.replaceWith(link);
  });
  return wrapper.innerHTML;
}

export function toCamelCase(str) {
  return (str || '')
    .toString()
    .trim()
    .split(/[\s_-]+/)
    .map((word, index) => {
      if (index === 0) {
        return word.charAt(0).toLowerCase() + word.slice(1);
      }
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join("");
}

export function formatAssigneeName(str) {
  if (!str || typeof str !== 'string') return '';
  let val = str.trim();
  if (val.includes('@')) {
    const namePart = val.split('@')[0];
    val = namePart
      .replace(/[._-]+/g, ' ')
      .split(' ')
      .filter(Boolean)
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(' ');
  }
  return val;
}
